// components/IDVerificationBadge.jsx

const BUSINESS_COLOR = '#15B4C4';

/**
 * Personal accounts: white circular badge with "ID Verified" text in black.
 * Business & Organizations accounts: badge in #15B4C4 with white text.
 */
export default function IDVerificationBadge({ fontSize = 10, isBusiness = false }) {
  return (
    <div
      style={{
        display: 'inline-block',
        padding: '3px 8px',
        borderRadius: 12,
        backgroundColor: isBusiness ? BUSINESS_COLOR : '#FFFFFF',
      }}
    >
      <span
        style={{
          color: isBusiness ? '#FFFFFF' : '#000000',
          fontSize,
          fontWeight: 700,
        }}
      >
        ID Verified
      </span>
    </div>
  );
}